
  export default {
    name: 'SidemenuHeader',
  };
